// extracted by mini-css-extract-plugin
module.exports = {"departure":"schedules_departure__eekIE","tertiary":"schedules_tertiary__tJIZ_","return":"schedules_return__6UBp7"};